__turbopack_context__.v({
  "answer": "anu-live-module__Fn6ROG__answer",
  "answerLabel": "anu-live-module__Fn6ROG__answerLabel",
  "composer": "anu-live-module__Fn6ROG__composer",
  "emptyConversation": "anu-live-module__Fn6ROG__emptyConversation",
  "evidenceNote": "anu-live-module__Fn6ROG__evidenceNote",
  "exchange": "anu-live-module__Fn6ROG__exchange",
  "header": "anu-live-module__Fn6ROG__header",
  "headerActions": "anu-live-module__Fn6ROG__headerActions",
  "integrationList": "anu-live-module__Fn6ROG__integrationList",
  "integrationRow": "anu-live-module__Fn6ROG__integrationRow",
  "integrationSignal": "anu-live-module__Fn6ROG__integrationSignal",
  "integrations": "anu-live-module__Fn6ROG__integrations",
  "lowerGrid": "anu-live-module__Fn6ROG__lowerGrid",
  "machine": "anu-live-module__Fn6ROG__machine",
  "metricTile": "anu-live-module__Fn6ROG__metricTile",
  "offline": "anu-live-module__Fn6ROG__offline",
  "page": "anu-live-module__Fn6ROG__page",
  "playgroundGrid": "anu-live-module__Fn6ROG__playgroundGrid",
  "polling": "anu-live-module__Fn6ROG__polling",
  "promptHeader": "anu-live-module__Fn6ROG__promptHeader",
  "promptLead": "anu-live-module__Fn6ROG__promptLead",
  "promptPanel": "anu-live-module__Fn6ROG__promptPanel",
  "question": "anu-live-module__Fn6ROG__question",
  "ready": "anu-live-module__Fn6ROG__ready",
  "roomLink": "anu-live-module__Fn6ROG__roomLink",
  "signalGrid": "anu-live-module__Fn6ROG__signalGrid",
  "signalHead": "anu-live-module__Fn6ROG__signalHead",
  "signalLead": "anu-live-module__Fn6ROG__signalLead",
  "signalNote": "anu-live-module__Fn6ROG__signalNote",
  "stopButton": "anu-live-module__Fn6ROG__stopButton",
  "suggestions": "anu-live-module__Fn6ROG__suggestions",
  "textButton": "anu-live-module__Fn6ROG__textButton",
  "transcript": "anu-live-module__Fn6ROG__transcript",
});
